let buildingTypes = [
  {
    value: "Office",
    name : "Bureaux",
  },
  {
    value: "Storage",
    name : "Stockage",
  },
  {
    value: "Production",
    name : "Production",
  },
  {
    value: "Sales",
    name : "Point de vente",
  },
  {
    value: "Other",
    name : "Autres",
  },
]

export default buildingTypes